import { ApplicationInsights } from '@microsoft/applicationinsights-web'

function addApplicationInsight(instrumentationKey) {
  if (!instrumentationKey) return

  const ai = new ApplicationInsights({ config: { instrumentationKey, disableCookiesUsage: true } })
  ai.loadAppInsights()
  ai.trackPageView()

  window.addEventListener('CookiebotOnAccept', function(e) {
    // eslint-disable-next-line no-undef
    var cookiebot = Cookiebot
    ai.getCookieMgr().setEnabled(cookiebot.consent.statistics)

    if (cookiebot.changed) location.reload()
  })

  window.addEventListener('CookiebotOnDecline', function(e) {
    // eslint-disable-next-line no-undef
    var cookiebot = Cookiebot
    ai.getCookieMgr().setEnabled(cookiebot.consent.statistics)
    if (cookiebot.changed) location.reload()
  })
}

export {
  addApplicationInsight
}
